__turbopack_context__.v({
  "closeButton": "MobilePopupLayout-module-scss-module__IkPoQq__closeButton",
  "container": "MobilePopupLayout-module-scss-module__IkPoQq__container",
  "header": "MobilePopupLayout-module-scss-module__IkPoQq__header",
  "title": "MobilePopupLayout-module-scss-module__IkPoQq__title",
});
